export default "__VITE_ASSET__Ds9gr8iX__"